<!-- This component doens't update the Vuex Product Store -->

<template>
  <slot
    :form-id="formId"
    :id="id"
    :selling-plan="sellingPlanId"
    :selling-plans="sellingPlans"
    :set-selling-plan-id="setSellingPlanId"
    :has-subscription="hasSubscription"
    :is-active="isActive"
    :set-subscription-active="setSubscriptionActive"
    :quantity="quantity"
    :set-quantity="setQuantity"
    :increaseQuantityByOne="increaseQuantityByOne"
    :decreaseQuantityByOne="decreaseQuantityByOne"
    :selected-variant="selectedVariant"
    :find-variants-by-options="findVariantsByOptions"
    :is-active-option="isActiveOption"
    :is-visible-option="isVisibleOption"
    :options="selectedOptions"
    :available="available"
    :addToCart="handleAddToCart"
    :loading="submitting || isLoading"
    :error="error"
    :add-error-message="addErrorMessage"
    :store-locator-url="storeLocatorUrl"
    :price="formatMoney(currentPrice.price)"
    :compare-at-price="
      currentPrice?.compareAtPrice && formatMoney(currentPrice.compareAtPrice)
    "
  />
</template>

<script>
export default {
  name: "ProductForm",
};
</script>

<script setup>
import {ref, computed} from "vue";
import {useStore} from "vuex";
import JSON5 from "json5";
import useProductForm from "@/vue/composables/useProductForm";
import {formatMoney} from "@shopify/theme-currency";
import {dispatchCartErrorToast} from "@/utils/cart-error-toast";

const store = useStore();
const storeLocatorUrl = "/pages/store-locator";
const submitting = ref(false);

const formId = "" + Math.random(); // Please notice: useId might be the same between two different Vue instances, so random might work better.
const props = defineProps(["product"]);

const product = JSON5.parse(props.product);

const {
  // ProductInfo
  id,
  quantity,
  sellingPlanId,

  // Quantity
  setQuantity,
  increaseQuantityByOne,
  decreaseQuantityByOne,

  // Options
  selectedVariant,
  findVariantsByOptions,
  isActiveOption,
  isVisibleOption,
  selectedOptions,

  // Subscription
  hasSubscription,
  isActive,
  setSubscriptionActive,
  sellingPlans,
  setSellingPlanId,

  // Add To Cart
  available,
  error,
  isLoading,
  addToCart,

  // Price
  currentPrice,
} = useProductForm({
  product,
});

const addErrorMessage = computed(() => {
  const e = error.value;
  if (!e) return "";
  return e.message || "Unable to add to cart.";
});

const handleAddToCart = async () => {
  if (!available.value) {
    window.location.href = storeLocatorUrl;
    return;
  }

  submitting.value = true;
  try {
    // `cart/addItem` already put the line in the cart, announced it and opened
    // the drawer before this resolves. Fetching the whole cart again here and
    // only then opening is what kept the drawer waiting on two round trips.
    await addToCart();

    if (error.value) {
      dispatchCartErrorToast(store, error.value);
      return;
    }
  } finally {
    submitting.value = false;
  }
};
</script>
